var ALL_EVENTS = '*';
function validateConfig(config) {
    if (typeof config.initialState === 'undefined') {
        throw new Error('Initial state must be provided to create a shared store');
    }
    if (!config.events) {
        throw new Error('Events must be provided to create a shared store');
    }
    if (!config.onEventChange) {
        throw new Error('onEventChange callback must be provided to create a shared store');
    }
    if (config.events.length === 0) {
        throw new Error('At least one event must be defined to create a shared store');
    }
    if (config.events.includes(ALL_EVENTS)) {
        throw new Error("Event name \"".concat(ALL_EVENTS, "\" is reserved and cannot be used as an event name"));
    }
    var invalidEvent = config.events.find(function (event) { return typeof event !== 'string'; });
    if (invalidEvent) {
        throw new Error("Event names must be of type string, received ".concat(typeof invalidEvent, ": \"").concat(invalidEvent, "\""));
    }
}
export function createSharedStore(config) {
    var _a;
    validateConfig(config);
    var state = config.initialState;
    var subs = (_a = {},
        _a[ALL_EVENTS] = new Set(),
        _a);
    var getState = function () { return state; };
    function subscribe(event, callback) {
        if (!subs[event]) {
            subs[event] = new Set();
        }
        subs[event].add(callback);
        return function () {
            var _a;
            if ((_a = subs[event]) === null || _a === void 0 ? void 0 : _a.has(callback)) {
                subs[event].delete(callback);
            }
        };
    }
    function notify(event) {
        if (subs[event]) {
            subs[event].forEach(function (cb) { return cb(); });
        }
    }
    function notifyAll() {
        if (subs[ALL_EVENTS]) {
            subs[ALL_EVENTS].forEach(function (cb) { return cb(); });
        }
    }
    function updateState(event, payload) {
        state = config.onEventChange(state, event, payload);
        notify(event);
        notifyAll();
    }
    function subscribeAll(callback) {
        if (!subs[ALL_EVENTS]) {
            subs[ALL_EVENTS] = new Set();
        }
        subs[ALL_EVENTS].add(callback);
        return function () {
            var _a;
            if ((_a = subs[ALL_EVENTS]) === null || _a === void 0 ? void 0 : _a.has(callback)) {
                subs[ALL_EVENTS].delete(callback);
            }
        };
    }
    return {
        getState: getState,
        updateState: updateState,
        subscribe: subscribe,
        subscribeAll: subscribeAll,
    };
}
//# sourceMappingURL=createSharedStore.js.map